<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-form
        ref="form"
        lazzy-validation
        @submit.prevent="submit"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ isEdit ? 'Modificar archivo' : 'Crear archivo' }}  </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  
                  <div
                    v-if="isEdit"
                  >
                    <v-switch
                      v-model="isEditFile"
                      label="Modificar archivo"
                    />

                    <v-file-input
                      v-if="isEditFile"
                      v-model="file"
                      accept="image/*"
                      label="Nombre de archivo"
                      :rules="[v => !!v || 'El archivo es obligatorio']"
                      :error-messages="isValidFile"
                      outlined
                      required
                    /> 

                    <v-img
                      v-else
                      class="foto2"
                      :src="item.foto"
                    />
                  <a :id="item.foto" :href="isDesarrollo + '?foto=' + item.foto" target="_blanck"></a>
                  </div>

                  <v-file-input
                    v-if="!isEdit"
                    v-model="file"
                    accept="image/*"
                    label="Nombre de archivo"
                    :rules="[v => !!v || 'El archivo es obligatorio']"
                    :error-messages="isValidFile"
                    outlined
                    required
                  /> 
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="close()"
            >
              Cerrar
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="showFile()"
            >
              Ver Completo
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              type="submit"
              :loading="isLoading"
            >
              Subir
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
// import BackendApi from '@/services/backend.service'
  import firebase from 'firebase'
  import 'firebase/storage'

  // const db = firebase.firestore()
  const storage = firebase.storage()
  const ref = storage.ref()

export default {
  data () {
    return {
      errors: {
        name: '',
        file: ''
      },
      isEditFile: false,
      dialog: false,
      item: null,
      isLoading: false,
      name: '',
      file: null,
      long_url: null,
      itemId: '',
      fotoUri: '',
    }
  },
  computed: {
    isEdit: function () {
      return this.item?.foto
    },
    isValidName () {
      return this.errors.name === undefined ? '' : this.errors.name[0]
    },
    isValidFile () {
      return this.errors.file === undefined ? '' : this.errors.file[0]
    },
    isDesarrollo () {
      return window.location.hostname.includes('localhost') ? 'http://localhost:8081/showFile' : 'https://app.expertosenpuertas.com/showFile'
    },
    fotoSeleccionado () {
      return this.item.foto ? this.item.foto : ''
    }

  },
  methods: {
    open (item, TipoDeDireccion) {
      this.errors = {
        name: '',
        file: ''
      }
      this.TipoDeDireccion = TipoDeDireccion
      this.item = item
      this.itemId = item.id
      if (this.isEdit) {
        this.name = item.name
        this.file = item.file
        this.long_url = item.long_url
      } else {
        this.name = null
        this.file = null
        this.long_url = null
      }

      this.dialog = true
    },
    close () {
      this.$refs.form.reset()
      this.isLoading = false
      // this.$emit('onDialogUploadFinish')
      this.dialog = false
    }, 
    async submit () {
      if (this.$refs.form.validate()) {
        this.isLoading = true

        if (!this.isEdit) {
          this.loading = true

          const archivo = this.file
          const refImg = ref.child('fotos/' + this.itemId + this.TipoDeDireccion + archivo.name)
          const metadata = { contentType: 'img/jpeg' }
          await refImg.put(archivo, metadata)
          .then(e => {
          })

          await ref.child('fotos/' + this.itemId + this.TipoDeDireccion + archivo.name).getDownloadURL()
          .then(url => {
            this.fotoUri = url
          })
          if (this.TipoDeDireccion === 'Real') {
            const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad/' + this.itemId, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                foto_direccion_real: this.fotoUri || '',
              })
            })
            const data = await response.json()
            if (data.success) {
              this.loading = false
              this.close()
              this.$emit('onUploadReal', this.fotoUri)
            } else {
              // this.loading = false
              // this.close()
              // this.$emit('onUploadReal', this.fotoUri)
            }
          } else {
            const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad/' + this.itemId, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                foto_direccion_fiscal: this.fotoUri || '',
              })
            })
            const data = await response.json()
            if (data.success) {
              this.loading = false
              this.close()
              this.$emit('onUploadFiscal', this.fotoUri)
            } else {
              // this.loading = false
              // this.close()
              // this.$emit('onUploadReal', this.fotoUri)
            }
          }

            // 
          this.loading = false
        } else {
          this.loading = true

          const archivo = this.file
          const refImg = ref.child('fotos/' + this.itemId + this.TipoDeDireccion + archivo.name)
          const metadata = { contentType: 'img/jpeg' }
          await refImg.put(archivo, metadata)
          .then(e => {
          })

          await ref.child('fotos/' + this.itemId + this.TipoDeDireccion + archivo.name).getDownloadURL()
          .then(url => {
            this.fotoUri = url
          })
          if (this.TipoDeDireccion === 'Real') {
              const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad/' + this.itemId, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                foto_direccion_real: this.fotoUri || '',
              })
            })
            const data = await response.json()
            if (data.success) {
              this.loading = false
              this.close()
              this.$emit('onUploadReal', this.fotoUri)
            } else {
              // this.loading = false
              // this.close()
              // this.$emit('onUploadReal', this.fotoUri)
            }
          } else {
              const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad/' + this.itemId, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                foto_direccion_fiscal: this.fotoUri || '',
              })
            })
            const data = await response.json()
            if (data.success) {
              this.loading = false
              this.close()
              this.$emit('onUploadFiscal', this.fotoUri)
            } else {
              // this.loading = false
              // this.close()
              // this.$emit('onUploadReal', this.fotoUri)
            }
          }

          this.loading = false
        }
      }
    },
    showFile () {
      const openFile = document.getElementById(this.item.foto)

      openFile.click()
    }
  }
}
</script>

<style>

.foto2 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
